import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { BackendApiService } from '../services/backend-api.service';
import { BaseUrlConstantsService } from '../services/base-url-constants.service';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-device-mac-usage-list',
  standalone: true,
  imports: [MatIconModule, CommonModule, FormsModule],
  templateUrl: './device-mac-usage-list.component.html',
  styleUrl: './device-mac-usage-list.component.scss'
})
export class DeviceMacUsageListComponent {
  @Input() macAddressClicked: string;
  @Input() filterType: string;
  @Input() startDate: string;
  @Input() endDate: string;

  @Output() closeListModal = new EventEmitter<void>();

  public listData: any[] = [];
  public isLoading: boolean = true;
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetchMacListData();
  }
  constructor(private service: BackendApiService) {}

  async fetchMacListData() {
    try {
      const result: any = await this.service.getDataV2(BaseUrlConstantsService.GET_MAC_LIST_DATA + `/${this.macAddressClicked}?filterType=${this.filterType}&startDate=${this.startDate}&endDate=${this.endDate}`);
      if (result.success === true) {
        this.listData = result.data;
        this.listData.forEach(item => {
          item.online_percentage = ((item.total_online_time / item.total_seconds) * 100).toFixed(2);
          item.offline_percentage = ((item.total_offline_time / item.total_seconds) * 100).toFixed(2);
        })
        console.log(this.listData)
        this.isLoading = false;
      }
      console.log(result)
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.isLoading = false;
    }
  }

  onClose() {
    this.closeListModal.emit();
  }

  secondsToDDHHMMSS(totalSeconds: number) {
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (num: number) => String(num).padStart(2, '0');

    return `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}
